import { curry, reduce, append } from 'ramda'

/**
 * Merges two arrays together.
 *
 * @type {function}
 * @param {Array} a
 * @param {Array} b
 */
const mergeArrays = curry((a, b) => reduce((carry, item) => append(item, carry), b, a))

export default mergeArrays
